import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import Container from '../Shared/Container';
import InnerContainer from '../Shared/InnerContainer';
import SectionHeader from '../Shared/SectionHeader';
import Card from '../Shared/Card';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

const Contact_Section = (props) => (

  <Container small blue>
    {console.log(marked(props.text))}
    <InnerContainer light>
      <SectionHeader light>
        Contact Info
      </SectionHeader>
      {/* <ContactCard> */}
      <SectionText dangerouslySetInnerHTML={{__html:
          marked(props.text, {sanitize: true})}}
      />
    {/* </ContactCard> */}

    </InnerContainer>
  </Container>
);

export default Contact_Section;

const ContactCard = Card.extend`
  width: 600px;
`;

const SectionText = styled.div`
  line-height: 1.4rem;
  font-size: 1.15rem;
  font-family: Lato;
  font-weight: 300;
  opacity: 1;
  text-align: center;
  letter-spacing: 0.25px;
  & p:last-of-type {
    margin-bottom: 0;
  }

  & a {
    color: inherit;
  }

  & h3 {
    margin-bottom: 0.5rem;
  }

   @media (max-width: 600px) {
     font-size: 1rem;
     line-height: 1.25rem;
   }
`;



// WEBPACK FOOTER //
// ./src/components/Contact_Section/index.js